module.exports = __webpack_public_path__ + "img/gallery06.dbd55740.png";